export const regearRedirect = (country, language) => {
  let regearUrl = "regear.arcteryx.com";
  if (country?.toLowerCase() === "ca") {
    regearUrl = language && language === "fr" ? "regear.arcteryx.ca/fr" : "regear.arcteryx.ca";
  }
  return regearUrl;
};
